import { HttpClient } from '@angular/common/http';

import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs/internal/Observable';
import {
  AcceptAuthorizationVerbiageRequestV1,
  AcceptAuthorizationVerbiageResponseV1,
  RetrieveAuthorizationVerbiageRequestV1,
  RetrieveAuthorizationVerbiageResponseV1,
} from '../models';
import { PaymentAuthorizationVerbiageService } from './payment-authorization-verbiage.service';

export class PaymentAuthorizationVerbiagePlatformService extends PaymentAuthorizationVerbiageService {
  constructor(
    private httpClient: HttpClient,
    protected appConfig: AppConfigSettings,
  ) {
    super(appConfig);
  }

  public retrieveAuthorizationVerbiageV1(
    tenantId: string,
    retrieveVerbiageRequest: RetrieveAuthorizationVerbiageRequestV1,
  ): Observable<RetrieveAuthorizationVerbiageResponseV1> {
    return this.httpClient.post<RetrieveAuthorizationVerbiageResponseV1>(
      `${this.baseUrl}/v1/tenants/${tenantId}/retrieve-verbiage`,
      retrieveVerbiageRequest,
    );
  }

  public acceptAuthorizationVerbiageV1(
    tenantId: string,
    acceptVerbiageRequest: AcceptAuthorizationVerbiageRequestV1,
  ): Observable<AcceptAuthorizationVerbiageResponseV1> {
    return this.httpClient.post<AcceptAuthorizationVerbiageResponseV1>(
      `${this.baseUrl}/v1/tenants/${tenantId}/accept-verbiage`,
      acceptVerbiageRequest,
    );
  }
}
